import React, { useState } from 'react'
import "./style/OrderModal.css"
export default function OrderModal({ isOpen, onClose, onSubmit, totalAmount, isLoading }) {
    const [customerDetails, setCustomerDetails] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        zipCode: '',
        notes: ''
    })

    const handleChange = (e) => {
        setCustomerDetails({
            ...customerDetails,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit(customerDetails)
    }

    if (!isOpen) return null

    return (
        <div className="order-modal-overlay" onClick={onClose}>
            <div className="order-modal" onClick={(e) => e.stopPropagation()}>
                <div className="order-modal-header">
                    <h2>📋 Order Details</h2>
                    <button className="order-modal-close" onClick={onClose}>✕</button>
                </div>

                <div className="order-modal-body">
                    <p className="order-total">Total Amount: <strong>Rs: {totalAmount}</strong></p>
                    
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Full Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter your full name"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Email Address <span className="required">*</span></label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Phone Number <span className="required">*</span></label>
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Enter your phone number"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Delivery Address <span className="required">*</span></label>
                            <textarea
                                name="address"
                                placeholder="Enter your full delivery address"
                                onChange={handleChange}
                                rows="3"
                                required
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group half">
                                <label>City</label>
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="City"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group half">
                                <label>ZIP Code</label>
                                <input
                                    type="text"
                                    name="zipCode"
                                    placeholder="ZIP Code"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Order Notes (Optional)</label>
                            <textarea
                                name="notes"
                                placeholder="Any special instructions or notes"
                                onChange={handleChange}
                                rows="2"
                            />
                        </div>

                        <button type="submit" className="order-submit-btn" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <span className="spinner"></span>
                                    Placing Order...
                                </>
                            ) : (
                                '✅ Place Order'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}